import { Shield, Bell, User } from 'lucide-react';
import { useAuth } from '../stores/auth';
import { useNavigate, Link } from 'react-router-dom';
import { phiText } from '../lib/phiConfig';

export function PageHeader({ title, subtitle, actions, children }) {
  const { profile, org } = useAuth();
  const nav = useNavigate();
  return (
    <div className="sticky top-0 z-30 bg-[var(--color-warm-white)]/95 backdrop-blur border-b border-[var(--color-border)]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-3 sm:py-4 flex flex-wrap items-center gap-3">
        {/* Mobile-only compact logo */}
        <img src="/om-icon.png" alt="Operon Management" className="mobile-only h-9 w-9 object-contain shrink-0" data-testid="mobile-logo" />
        <div className="flex-1 min-w-0">
          <h1 className="font-display text-lg sm:text-xl font-semibold text-[var(--color-ink)] truncate leading-tight" data-testid="page-title">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-[var(--color-muted)] truncate mt-0.5">{subtitle}</p>
          )}
        </div>
        <div className="flex items-center gap-2 flex-wrap justify-end ml-auto max-w-full">
          <Link to="/settings/compliance" data-testid="hipaa-secured-badge" className="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-white border border-[rgba(13,140,140,0.30)] text-[#0B6F6F] text-xs font-medium hover:bg-[rgba(13,140,140,0.06)] transition-colors">
            <Shield size={13} />
            {phiText('HIPAA Secured', 'Secured')}
          </Link>
          {actions}
          <button
            data-testid="header-user-menu"
            onClick={() => nav('/more')}
            className="h-9 w-9 rounded-full bg-white border border-[var(--color-border)] hidden sm:flex items-center justify-center text-[var(--color-slate)] hover:bg-[var(--color-surface-2)] transition-colors"
            aria-label="User menu"
          >
            <User size={16} />
          </button>
        </div>
      </div>
      {children && (
        <div className="max-w-7xl mx-auto px-4 lg:px-8 pb-3">{children}</div>
      )}
    </div>
  );
}
